import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function load (component) {
  return () => System.import(`../components/${component}.vue`)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'country',
      component: load('view/Country')
    },
    {
      path: '/appointment',
      name: 'countryAppointment',
      component: load('view/Country')
    },
    {
      path: '/reserve',
      name: 'countryReserves',
      component: load('view/CountryReserve')
    },
    {
      path: '/exclusive/:doctorID/:code?',
      name: 'exclusivePage',
      component: load('view/Exclusive')
    },
    {
      path: '/:country',
      name: 'prefix',
      component: load('layout/Prefix'),
      children: [
        {
          path: 'appointment/:code?',
          name: 'appointment',
          component: load('view/Appointment'),
          meta: {
            forVisitors: true,
            name: 'Citas'
          }
        },
        {
          path: 'reserve/:code?',
          name: 'reserve',
          component: load('view/Reserve'),
          meta: {
            forVisitors: true,
            name: 'Reservas'
          }
        },
        {
          path: 'bonuses/:code?',
          name: 'bonuses',
          component: load('view/bonuses/Register'),
          meta: {
            forVisitors: true,
            name: 'Bonos'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js